var PES = PES || {};
PES.ExitIntentModal = function () {

    let displayExitModal = async function (pageUrl) {
        const hostname = new URL(pageUrl).hostname;
        const apiString = "/api/content-exit-intent-modal?state=live&locale";
        const modal = document.getElementById("exit-intent-modal");
        const locale = modal.dataset.locale;
        const closeButton = document.querySelector('[data-modal-button-close]');
        let localStorageData = JSON.parse(localStorage.getItem("dismissExitModal"));
        const htmlTag = document.getElementsByTagName("html")[0];
        let enableMouseleaveTrigger = true;
        //define icons
        let buttonIcon = null;
        const iconDownloadSmall = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 4.5L8.5 1.5L11.5 4.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.5 2V9.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.5 9.5V13.5H14.5V9.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

        const iconDownloadMedium = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 11L12 15L16.4853 11" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 2.99999V15"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 15.5V19.5H20.5V15.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

        const iconArrowTopRightSmall = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 3.5H12.5L12.5 9.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.5 3.5L3.5 12.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

        const iconArrowTopRightMedium = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 4.5H19.5V14.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.5 4.5L5 19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

        //items to be populated
        const modalImage = document.querySelector(".exit-modal__container--image img");
        const modalTitle = document.querySelector(".exit-modal__container--content h2");
        const modalText = document.querySelector(".exit-modal__container--content .modal-text");
        const modalButtonContainer = document.querySelector(".exit-modal__container--content .modal-button-container");
        const cartElement = document.getElementById("item-counter");
        let itemsInCart = 0;
        function updateItemsInCart() {
            itemsInCart = parseInt(cartElement.innerText.trim(), 10) || 0;
            // Call useExitModal with the updated itemsInCart value
            fetchDataAndUseExitModal();
        }

        if (cartElement) {
            const observer = new MutationObserver(() => {
                updateItemsInCart();
            });

            observer.observe(cartElement, { childList: true, subtree: true, characterData: true });
        }

        // Function to convert SVG string to DOM element
        function createSvgElement(svgString) {
            const parser = new DOMParser();
            let svgElement = parser.parseFromString(svgString, "image/svg+xml").documentElement;
            return svgElement;

        }
        function selectIcon(icon) {
            switch(icon) {
                case "arrow-top-right-16":
                    buttonIcon = createSvgElement(iconArrowTopRightSmall);
                    break;
                case "arrow-top-right-24":
                    buttonIcon = createSvgElement(iconArrowTopRightMedium);
                    break;
                case "download-16":
                    buttonIcon = createSvgElement(iconDownloadSmall);
                    break;
                case "download-24":
                    buttonIcon = createSvgElement(iconDownloadMedium);
                    break;
                default: null;
            }
        }

        const domain = hostname == "localhost" ? "localhost" : hostname.match(/([a-z0-9-]+\.[a-z]+)$/i)[0];

        let cmsHost = "";

        if (domain !== "officetimeline.com") {
            cmsHost = domain == "localhost" ? `http://localhost:1337${apiString}=${locale}` : `https://compass.pes-integration.com${apiString}=${locale}`
        } else {
            cmsHost = `https://compass.${domain}${apiString}=${locale}`
        }

        const router = { pathname: window.location.pathname };

        function setShowExitIntentModal(modalIsDisplayed) {
            function handleMouseLeave(e) {
                if (modalIsDisplayed && enableMouseleaveTrigger && e.y < 20) {

                    htmlTag.classList.add("overflow-hidden");
                    modal.setAttribute("data-exit-modal-is-visible", modalIsDisplayed);
                }
            }
            document.addEventListener("mouseleave", handleMouseLeave);
            return function () {
                document.removeEventListener("mouseleave", handleMouseLeave)
            };
        }

        function useExitModal(data) {
            let modalState = { show: false, modalData: null };

            function isPathInArray(paths) {
                const currentPath = router.pathname;
                return paths.some((path) => {
                    if (path.includes("*")) {
                        const basePath = path.replace("*", "");
                        return currentPath.startsWith(basePath);
                    }
                    return currentPath === path;
                });
            }

            data.map((elem) => {
                if (elem) {
                    let visibleModals = [];

                    // Iterate through all items and collect eligible banners
                    for (const item of data) {
                        const includePaths = item.includePaths?.split(/[\s,]+/).filter(Boolean) || [];
                        const excludePaths = item.excludePaths?.split(/[\s,]+/).filter(Boolean) || [];

                        const isRouteIncluded = includePaths.length > 0 ? isPathInArray(includePaths) : true;
                        const isRouteExcluded = excludePaths.length > 0 ? isPathInArray(excludePaths) : false;

                        if (isRouteIncluded && !isRouteExcluded) {
                            const wasDismissed = localStorageData?.find((obj) => obj.id === item.id);
                            let isEligible = true;
                            if (wasDismissed) {
                                isEligible = new Date(wasDismissed.dismissAt) < new Date(item.publishedAt);
                                if (isEligible) {
                                    // Remove old dismiss entries if republished
                                    const dataIds = new Set(item.localizations.map((loc) => loc.id)).add(item.id);
                                    localStorage.setItem("dismissExitModal", JSON.stringify(localStorageData.filter((obj) => !dataIds.has(obj.id))));
                                }
                            }

                            if (!itemsInCart && item.type === "cartHasItems") {
                                continue;
                            }

                            if (isEligible) {
                                visibleModals.push(item);
                            }
                        }
                    }

                    // Pick the first banner in the sorted list to display
                    const visibleModalData = visibleModals.length > 0 ? visibleModals[0] : null;
                    const isModalVisible = !!visibleModalData;

                    setShowExitIntentModal(isModalVisible);
                    modalState = { show: isModalVisible, modalData: visibleModalData };
                } else {
                    modalState = { show: false, modalData: null };
                }
            });

            return modalState;
        }

        function fetchDataAndUseExitModal() {
            // Replace fetchData function with a promise
            new Promise((resolve, reject) => {
                fetch(cmsHost)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => resolve(data))
                    .catch(error => reject(error));
            })
            .then(data => {
                if (!data) {
                    return;
                }

                const modalInfo = data.banners;
                const { modalData, show } = useExitModal(modalInfo);
                if (!modalData) {
                    return;
                }
                const { type, localizations, ctaArray, content, title, image } = modalData;

                if (modalData) {
                    // Check if elements are correctly selected
                    if (modalImage) {
                        modalImage.src = image.url;
                        modalImage.alt = image.alternativeText;
                        modalImage.width = image.width;
                        modalImage.height = image.height;
                    }

                    if (modalTitle) {
                        modalTitle.innerText = title;
                    }

                    if (modalText) {
                        modalText.innerHTML = content;
                    }

                    if (ctaArray.length < 1) {
                        modalButtonContainer.remove();

                    } else {
                        if (modalButtonContainer) {
                            modalButtonContainer.innerHTML = ''; // Clear existing buttons
                            ctaArray.forEach((cta) => {
                                if (!!cta.path) {
                                    const button = document.createElement('a');
                                    button.innerText = cta.label;
                                    button.classList.add(cta.type, cta.size)
                                    button.setAttribute('href', cta.path);
                                    if (cta.openInNewTab) {
                                        button.setAttribute('_target', 'blank');
                                        button.setAttribute('rel', 'noopener');
                                    }
                                    if (cta.icon) {
                                        selectIcon(cta.icon);
                                        button.setAttribute('icon-position', cta.iconPosition);
                                        button.appendChild(buttonIcon);
                                    }
                                    button.setAttribute('data-tid', cta.idAttr);
                                    modalButtonContainer.appendChild(button);
                                }
                            });
                        }
                    }
                }

                function hideModal() {
                    closeModal(modalData.id);
                    htmlTag.classList.remove("overflow-hidden");
                    modal.setAttribute("data-exit-modal-is-visible", "false");

                    return function () {
                        closeButton.removeEventListener("click", hideModal);
                        document.removeEventListener("keydown", handleKeyDown);
                        if (modalButtonContainer) {
                            modalButtonContainer.removeEventListener("click", handleButtonClick);
                        }
                    }
                };

                function handleKeyDown(event) {
                    if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
                        hideModal();
                    }
                }

                function handleButtonClick(event) {
                    if (event.target.tagName === 'A') {
                        setTimeout(function () {
                            hideModal();
                        }, 100);
                    }
                }

                closeButton.addEventListener("click", hideModal);
                document.addEventListener("keydown", handleKeyDown);
                if (modalButtonContainer) {
                    modalButtonContainer.addEventListener("click", handleButtonClick);
                }

                if (modalData) {
                    const modalLocales = modalData.localizations;
                    let localStorageData = JSON.parse(localStorage.getItem("dismissExitModal"));

                    if (localStorageData) {
                        const existingItem = localStorageData.find((obj) => obj.id === modalData.id);
                        let show = false;

                        if (existingItem) {
                            const dismissAt = new Date(existingItem.dismissAt);
                            const publishedAt = new Date(modalData.publishedAt);

                            if (dismissAt > publishedAt) {
                                show = false;
                            } else {
                                show = true;
                                localStorage.removeItem("dismissExitModal");
                            }

                            modalLocales.forEach((elem) => {
                                const existingLocale = localStorageData.find((obj) => obj.id === elem.id);
                                if (existingLocale) {
                                    const dismissAtLocale = new Date(existingLocale.dismissAt);
                                    const publishedAtLocale = new Date(elem.publishedAt);

                                    if (dismissAtLocale > publishedAtLocale) {
                                        show = false;
                                    } else {
                                        show = true;
                                        localStorage.removeItem("dismissExitModal");
                                    }
                                }
                            });
                        }

                        setShowExitIntentModal(show);
                        return;
                    } else {
                        setShowExitIntentModal(true);
                    }
                }

                function closeModal(id) {
                    enableMouseleaveTrigger = false;
                    setShowExitIntentModal(false);
                    modal.setAttribute("data-exit-modal-is-visible", false);

                    if (localStorageData === null) {
                        const newData = [];
                        newData.push({ id: id, dismissAt: new Date() });
                        if (localizations) {
                            localizations.map((elem) => {
                                newData.push({ id: elem.id, dismissAt: new Date() });
                            });
                            localStorage.setItem("dismissExitModal", JSON.stringify(newData));
                        }
                    } else {
                        const existingIndex = localStorageData.findIndex((obj) => obj.id === id);
                        if (existingIndex > -1) {
                            localStorageData[existingIndex].dismissAt = new Date();
                        } else {
                            localStorageData.push({ id: id, dismissAt: new Date() });
                        }
                        localizations.map((elem) => {
                            const existingLocale = localStorageData.findIndex((obj) => {
                                if (obj.id === elem.id) {
                                    return elem.id;
                                }
                            });
                            if (existingLocale > -1) {
                                localStorageData[existingLocale].dismissAt = new Date();
                            } else {
                                localStorageData.push({ id: elem.id, dismissAt: new Date() });
                            }
                        });
                        localStorage.setItem("dismissExitModal", JSON.stringify(localStorageData));
                    }
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
        }

        // Initial call to fetch data and use exit modal
        fetchDataAndUseExitModal();
    }

    var init = function (envUrl) {
        displayExitModal(envUrl);
    };

    return {
        init: init
    };
}();